import { baseBackend } from "../../../../api/base/baseUrl";

const RATES_ZONE_URL = "/api/v2/rates/zone";

export async function getRatesZoneListRequest() {
  const response = await baseBackend.get(RATES_ZONE_URL);
  return response.data;
}

export async function getRatesZoneByIdRequest(id) {
  const response = await baseBackend.get(`${RATES_ZONE_URL}/id/${id}`);
  return response.data;
}

export async function createRatesZoneRequest(payload) {
  const response = await baseBackend.post(RATES_ZONE_URL, payload);
  return response.data;
}

export async function updateRatesZoneRequest(payload) {
  const response = await baseBackend.put(RATES_ZONE_URL, payload);
  return response.data;
}

export async function deleteRatesZoneRequest(id) {
  const response = await baseBackend.delete(`${RATES_ZONE_URL}/id/${id}`);
  return response.data;
}
